import { render, staticRenderFns } from "./TurnitupList.vue?vue&type=template&id=55171fbe&scoped=true"
import script from "./TurnitupList.vue?vue&type=script&lang=js"
export * from "./TurnitupList.vue?vue&type=script&lang=js"
import style0 from "./TurnitupList.vue?vue&type=style&index=0&id=55171fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55171fbe",
  null
  
)

export default component.exports